
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/category/[id]",
      function () {
        return require("private-next-pages/news/category/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/category/[id]"])
      });
    }
  